export default __webpack_public_path__ + "61ff1ea1a881ccfba8bc83ca42244bea.ico";